import { media } from "components/designV2/breakpoints";
import { ColorV2 } from "config/colors";
import { TypographyV2 } from "config/font";
import styled, { css } from "styled-components";

export const Toolbar = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const ControlsGrid = styled.div<{ $hasDropdowns: boolean }>`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas: ${(props) =>
    props.$hasDropdowns
      ? '"toggle options" "dropdowns dropdowns"'
      : '"toggle options"'};
  column-gap: 16px;
  row-gap: 16px;
  align-items: end;

  ${(props) =>
    props.$hasDropdowns &&
    css`
      ${media.desktopXL} {
        grid-template-columns: auto 1fr auto;
        grid-template-areas: "toggle dropdowns options";
      }
    `}
`;

export const DropdownsCell = styled.div`
  grid-area: dropdowns;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
`;

export const OptionsCell = styled.div`
  grid-area: options;
  display: flex;
  justify-content: flex-end;
  align-items: flex-end;
  gap: 12px;
`;

export const DateFilterSlot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ViewTabs = styled.div`
  grid-area: toggle;
  justify-self: start;
  display: inline-flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 16px;
  padding: 8px 16px;
  border-radius: 16px;
  background: ${ColorV2.White};
`;

export const ViewTab = styled.button<{ $isActive: boolean }>`
  ${TypographyV2.b1}
  border: none;
  border-radius: 12px;
  padding: 8px 16px;
  color: ${ColorV2.Blue1};
  background: transparent;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.15s ease;

  &:hover {
    background: ${ColorV2.Blue7};
  }

  ${(props) =>
    props.$isActive &&
    css`
      background: ${ColorV2.Blue6};

      &:hover {
        background: ${ColorV2.Blue6};
      }
    `}
`;
